@use "styles" as *;

.me-teaser-layout {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: space(5);

  > * {
    grid-column: span 12;

    @include media-breakpoint-up(sm) {
      grid-column: span 6;
    }

    @include media-breakpoint-up(lg) {
      grid-column: span 4;
    }
  }

  > me-teaser[variant=lead] {
    grid-column: span 12;
  }
}

